import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataExternalApi, NodeDataUpdateExternalApi, PublicTraceEntry, VendorIntegration } from '@onefootprint/request-types/dashboard';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import useDirty from '@/components/playbook-builder/hooks/use-dirty';
import type { ApplyEditMutation } from '../../../base-node';
import type { VendorIntegrationFormData } from '../../types';
import { getDefaultValues } from '../../utils/get-default-values';
import ConfigurationSection from '../configuration-section';
import IntegrationLogsSection from '../integration-logs-section';
import VendorIntegrationForm, { VENDOR_INTEGRATION_FORM_ID } from '../vendor-integration-form';
export type VendorIntegrationContentProps = {
  node: {
    id: string;
    data: ApiNodeDataExternalApi;
  };
  mutation: ApplyEditMutation;
  canEdit: boolean;
  traceEntry?: PublicTraceEntry;
  integrations: VendorIntegration[];
  onSubmit?: (data: NodeDataUpdateExternalApi) => void; // For storybook testing
};
const VendorIntegrationContent = t0 => {
  const $ = _c(28);
  const {
    node,
    mutation,
    canEdit,
    traceEntry,
    integrations,
    onSubmit
  } = t0;
  const {
    toggle
  } = useDirty();
  const t1 = !canEdit;
  let t2;
  if ($[0] !== integrations || $[1] !== node) {
    t2 = getDefaultValues({
      node,
      integrations
    });
    $[0] = integrations;
    $[1] = node;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = {
      disabled: t1,
      defaultValues: t2
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const formMethods = useForm(t3);
  const {
    formState: t4
  } = formMethods;
  const {
    isDirty
  } = t4;
  let t5;
  if ($[6] !== canEdit || $[7] !== isDirty || $[8] !== toggle) {
    t5 = () => {
      if (canEdit) {
        toggle(VENDOR_INTEGRATION_FORM_ID, isDirty);
      }
    };
    $[6] = canEdit;
    $[7] = isDirty;
    $[8] = toggle;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== canEdit || $[11] !== isDirty) {
    t6 = [isDirty, canEdit];
    $[10] = canEdit;
    $[11] = isDirty;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useEffect(t5, t6);
  let t7;
  if ($[13] !== canEdit || $[14] !== integrations || $[15] !== mutation || $[16] !== node || $[17] !== onSubmit || $[18] !== traceEntry) {
    t7 = canEdit ? <VendorIntegrationForm node={node} mutation={mutation} integrations={integrations} onSubmit={onSubmit} /> : <ConfigurationSection node={node} isCollapsible={!!traceEntry} />;
    $[13] = canEdit;
    $[14] = integrations;
    $[15] = mutation;
    $[16] = node;
    $[17] = onSubmit;
    $[18] = traceEntry;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== traceEntry) {
    t8 = traceEntry && <IntegrationLogsSection traceEntry={traceEntry} />;
    $[20] = traceEntry;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = <div className="flex flex-col gap-4">{t7}{t8}</div>;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== formMethods || $[26] !== t9) {
    t10 = <FormProvider {...formMethods}>{t9}</FormProvider>;
    $[25] = formMethods;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};
export default VendorIntegrationContent;